"use client";

import * as styles from "./Stub.module.scss";

export interface StubProps {
	name: string;
	intent: string;
	height?: number | string;
	children?: React.ReactNode;
}

/**
 * Visual placeholder rendered by every stubbed composite, block, and
 * template variant in the boilerplate (STORE-001).
 *
 * - Dashed-border box, neutral background, monospace label.
 * - Reviewers can immediately distinguish "wired" from "stub" in any
 *   Storybook story.
 * - As subsequent tickets land, each stub is replaced with a real
 *   implementation; the import surface is the only thing that changes.
 *
 * Do not use in production code paths; this lives under `_internal/` to
 * signal that it's scaffolding.
 */
export function Stub({ name, intent, height, children }: StubProps) {
	return (
		<div
			role="presentation"
			data-stub={name}
			className={styles["stub"]}
			style={height ? { minHeight: height } : undefined}
		>
			<div className={styles["stub__label"]}>
				<strong className={styles["stub__tag"]}>[STUB]</strong>{" "}
				<span className={styles["stub__name"]}>{name}</span>
			</div>
			<small className={styles["stub__intent"]}>{intent}</small>
			{children ? (
				<div className={styles["stub__slot"]}>{children}</div>
			) : null}
		</div>
	);
}
